/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const StarHalfFilledColoredBoldIcon = /*#__PURE__*/ createSvgIcon(
  'StarHalfFilledColoredBoldIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M10.25 1.51a1.24 1.24 0 00-.33 0 1 1 0 00-.58.59L7.65 7.27H2.72a1 1 0 00-1 .9 1 1 0 00.35.77l4.23 3.22-1.59 5.12a1 1 0 00.64 1.18 1 1 0 00.84-.16l4.06-3.14V1.51z"
            fill="#FFC936"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.853 1.014c.154-.02.31-.02.463 0l.434.059v14.332L6.49 18.7l-.006.004a1.5 1.5 0 01-1.26.24l-.02-.005-.02-.007a1.5 1.5 0 01-.96-1.77l.004-.015 1.49-4.801-3.962-3.017-.011-.009a1.5 1.5 0 01-.525-1.155v-.023l.002-.022a1.5 1.5 0 011.5-1.35l-.002.5v-.5h4.567l-.112.345.475.155v-.5h-.363l1.58-4.833.003-.009a1.5 1.5 0 01.87-.885l.055-.02.058-.008zM9.75 2.455L8.012 7.77H2.717a.5.5 0 00-.497.428.5.5 0 00.166.354l4.495 3.422-1.688 5.437a.5.5 0 00.303.57.5.5 0 00.394-.082l3.86-2.984V2.455z"
            fill="#A32E00"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.395 1.266a1.45 1.45 0 012.21.705l.003.01 1.558 4.78h4.637l.06.014a1.43 1.43 0 01.8 2.591l-3.915 3 1.525 4.752a1.44 1.44 0 01-2.255 1.573l-.003-.002-3.764-2.905-3.752 2.902a1.43 1.43 0 01-1.284.256l-.008-.003-.008-.002a1.45 1.45 0 01-.966-1.805l.002-.007 1.51-4.76-3.953-3.039-.009-.007a1.43 1.43 0 01-.532-1.164v-.01a1.45 1.45 0 011.45-1.385h4.577l1.585-4.782.003-.007a1.45 1.45 0 01.53-.705zm.836 2.943l1.483 4.551h4.45l-3.751 2.875 1.404 4.374-3.567-2.752-3.564 2.756 1.39-4.378L4.336 8.76h4.385l1.509-4.55z"
            fill="#A32E00"
          />
        </>
      ),
    },
  },
  true
);

export default StarHalfFilledColoredBoldIcon;
